// extracted by mini-css-extract-plugin
export default {"draggableview":"draggableview_f472741a888005aeadc7"};